import BaseService from "./geral/BaseService";

const base = "BigPicture";

export default class BigPictureService extends BaseService{
    
    constructor(props){
        super(props)
    }

    ListarAno = () => {
        return super.httpGet(`/${base}/ListarAno`);
    }
    
    ListarClientes = () => {
        return super.httpGet(`/${base}/ListarClientes`);
    }
    
    GerarRelatorio = (parcId="", nomCliente="", dataBase="") => {
        return super.httpGet(`/${base}/GerarRelatorio?parcId=${parcId}&nomeCliente=${nomCliente}&dataBase=${dataBase}`);
    }

}


// WEBPACK FOOTER //
// ./src/services/BigPictureService.js